<template>
  <div>
    <div style="width:1280px">
      <img :src="adminIntro1" usemap="#map" name="adminIntro1" />

      <map name="map">
        <area
          shape="rect"
          coords="337,462,678,528"
          v-bind:href="
            `/membership/${$store.state.mallId}/home?init=coming&mall_name=${mall_name}&mall_id=${mall_id}&access_token=${access_token}`
          "
          target="_blank"
        />
      </map>
    </div>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";

export default {
  data: () => ({
    adminIntro1: require("../../../assets/membership/images/app_main.png"),
    mall_name: "",
    mall_id: "",
    access_token: "",
  }),

  methods: {
    getMemberInfo: async function() {
      try {
        let res = await M.api(M.entry("/get/membership/usage"));
        sessionStorage.setItem("mall_name", res.mall_name);
        this.mall_name = res.mall_name;
      } catch (e) {
        //
      }
    },
    setDatas: function() {
      console.log(this.$route.query);
      this.mall_id = this.$route.query.mall_id;
      this.access_token = this.$route.query.access_token;
    },
  },
  mounted: async function() {
    await this.getMemberInfo();
    this.setDatas();
  },
};
</script>
